import {GameBoard, GameConfig, GameData, GamePlay, GamePlayKey, GameSetup} from "../types";
import {v4 as uuid} from "uuid";
import countriesJson from "./res/countries.json";

export type Country = {
  name: string,
  cc: string,
}

export const ALL_COUNTRIES: Country[] = countriesJson as Country[];

export const WORLD_COUNTRIES: Country[] = ALL_COUNTRIES;

export const EUROPE_COUNTRIES: Country[] = [
  $CC("AL"), $CC("AM"), $CC("AT"), $CC("AZ"), $CC("BY"), $CC("BE"), $CC("BA"), $CC("BG"), $CC("HR"), $CC("CY"), $CC("CZ"), $CC("DK"), $CC("EE"), $CC("FI"), $CC("FR"), $CC("GE"), $CC("DE"), $CC("GR"), $CC("HU"), $CC("IS"), $CC("IE"), $CC("IT"), $CC("KZ"), $CC("LV"), $CC("LT"), $CC("MD"), $CC("NL"), $CC("NO"), $CC("PL"), $CC("PT"), $CC("RO"), $CC("RU"), $CC("RS"), $CC("SK"), $CC("SI"), $CC("ES"), $CC("SE"), $CC("CH"), $CC("TR"), $CC("UA"), $CC("GB"),
];

export const AFRICA_COUNTRIES: Country[] = [
  $CC("DZ"), $CC("AO"), $CC("BJ"), $CC("BW"), $CC("BF"), $CC("BI"), $CC("CM"), $CC("CF"), $CC("TD"), $CC("CI"), $CC("CD"), $CC("DJ"), $CC("EG"), $CC("GQ"), $CC("ER"), $CC("ET"), $CC("GA"), $CC("GM"), $CC("GH"), $CC("GN"), $CC("GW"), $CC("KE"), $CC("LS"), $CC("LR"), $CC("LY"), $CC("MG"), $CC("MW"), $CC("ML"), $CC("MR"), $CC("MA"), $CC("MZ"), $CC("NA"), $CC("NE"), $CC("NG"), $CC("CG"), $CC("RW"), $CC("SN"), $CC("SL"), $CC("SO"), $CC("ZA"), $CC("SD"), $CC("TZ"), $CC("TG"), $CC("TN"), $CC("UG"), $CC("ZM"), $CC("ZW"),
];

export const ASIA_COUNTRIES: Country[] = [
  $CC("AF"), $CC("AM"), $CC("BD"), $CC("BT"), $CC("BN"), $CC("KH"), $CC("CN"), $CC("IN"), $CC("ID"), $CC("IR"), $CC("IQ"), $CC("IL"), $CC("JP"), $CC("JO"), $CC("KZ"), $CC("KW"), $CC("KG"), $CC("LA"), $CC("LB"), $CC("MY"), $CC("MV"), $CC("MN"), $CC("MM"), $CC("NP"), $CC("KP"), $CC("OM"), $CC("PK"), $CC("PH"), $CC("QA"), $CC("RU"), $CC("SA"), $CC("KR"), $CC("LK"), $CC("SY"), $CC("TW"), $CC("TJ"), $CC("TH"), $CC("TL"), $CC("TR"), $CC("TM"), $CC("AE"), $CC("UZ"), $CC("VN"), $CC("YE"),
];

export const NORTH_AMERICA_COUNTRIES: Country[] = [
  $CC("BS"), $CC("BB"), $CC("BZ"), $CC("CA"), $CC("CR"), $CC("CU"), $CC("DO"), $CC("SV"), $CC("GL"), $CC("GT"), $CC("HT"), $CC("HN"), $CC("JM"), $CC("MX"), $CC("NI"), $CC("PA"), $CC("TT"), $CC("US")
];

export const SOUTH_AMERICA_COUNTRIES: Country[] = [
  $CC("AR"), $CC("BO"), $CC("BR"), $CC("CL"), $CC("CO"), $CC("EC"), $CC("FK"), $CC("GF"), $CC("GY"), $CC("PY"), $CC("PE"), $CC("SR"), $CC("UY"), $CC("VE")
];

export const AUSTRALIA_COUNTRIES: Country[] = [
  $CC("AU"), $CC("FJ"), $CC("NC"), $CC("NZ"), $CC("PG"), $CC("SB"), $CC("VU")
];

export class MapLayout {

  constructor(readonly level: MapDifficultyLevel, readonly countries: Country[]) {
  }
}

export function $CC(code: string): Country {
  return ALL_COUNTRIES.find(c => c.cc.toLowerCase() === code.toLowerCase());
}

export abstract class MapDifficultyLevel {

  constructor(readonly name: string, readonly text: string, readonly description: string, readonly allCountries: Country[]) {
  }
}

export class MapGameConfig extends GameConfig {

  constructor(readonly level: MapDifficultyLevel) {
    super();
  }
}

export class MapGameSetup extends GameSetup {

  constructor(key: GamePlayKey) {
    super(key);
  }
}

export class MapGameData extends GameData<MapGameBoard> {

  static async create(config: MapGameConfig): Promise<MapGameData> {
    const loader = new MapGamesLoader();
    const layout = await loader.getRandomGame(config.level);
    const setup = new MapGameSetup(new GamePlayKey("map", uuid()));
    const now = Date.now();
    return new MapGameData(new GamePlay(setup, now, 0, 0, 0, new MapGameBoard(config.level, layout)));
  }
}

export class MapGamesLoader {

  async getRandomGame(level: MapDifficultyLevel): Promise<MapLayout> {
    const allCountries = [...level.allCountries];
    const countries: Country[] = [];
    const total = Math.min(30, allCountries.length);
    for (let i = 0; i < total; i++) {
      countries.push(allCountries.splice(Math.floor(allCountries.length * Math.random()), 1)[0]);
    }
    return new MapLayout(level, countries);
  }
}

export class MapGameBoard extends GameBoard {

  constructor(readonly level: MapDifficultyLevel, readonly layout: MapLayout) {
    super();
  }

  getPoints(moves: number): number {
    return moves;
  }

  toJSON(): any {
    return this;
  }
}